import axios from '../library/axiosConfig'
export default {
  //通勤找房
  commuting(data) {
    return axios.post("/find/commuting", {}, { baseURL: axios.defaults.roomFindWeb, params: data });
  },
  //地图找房
  map(data) {
    return axios.post("/find/map", {}, { baseURL: axios.defaults.roomFindWeb, params: data });
  },
  //列表找房
  list(data) {
    return axios.post("/find/list", {}, { baseURL: axios.defaults.roomFindWeb, params: data });
  },
  //筛选项
  getFilterItems(data) {
    return axios.post("/find/getFilterItems", {}, { baseURL: axios.defaults.roomFindWeb, params: data });
  },
  //房间详情高度重要信息
  roomDetailHigh(data) {
    return axios.get("/find/v3/roomDetail/detailHigh", { baseURL: axios.defaults.roomFindWeb, params: data });
  },
  roomDetailLow(data) {
    return axios.get("/find/v3/roomDetail/detailLow", { baseURL: axios.defaults.roomFindWeb, params: data });
  },
  renterData(data) {
    return axios.get("/find/v3/roomDetail/renterData", { baseURL: axios.defaults.roomFindWeb, params: data });
  },
  recommendRooms(data) {
    return axios.get("/roomdetail/rcmd/recommendRooms", {baseURL: axios.defaults.roomFindWeb, params: data});
  },
  // CMS模板房源列表
  activityRoomList(data) {
    return axios.post("/activity/activityRoomList", {}, {baseURL: axios.defaults.roomFindWeb, params: data});
  },
  //推荐列表
  getRecommendRoom(data) {
    return axios.post("/rcmd/roomList", {}, { baseURL: axios.defaults.roomFindWeb, params: data });
  },
  //一键找房-经纪人
  getBrokers(data) {
    return axios.post("/rcmd/brokers", {}, { baseURL: axios.defaults.roomFindWeb, params: data });
  },
  //一键找房-品牌店铺
  getBrands(data) {
    return axios.post("/rcmd/brands", {}, { baseURL: axios.defaults.roomFindWeb, params: data });
  },
  v2home(data) {
    return axios.get("/ali/v2/home", { baseURL: axios.defaults.roomFindWeb, params: data });
  },
  // 房间详情baseInfoBrandCustom
  roomDefailBaseInfoBrandCustom(data) {
    return axios.post('/v2/find/roomDetail/basicBrandInfo', data, {baseURL: axios.defaults.roomFindWeb, brandCustom: true, onlyChannel: true})
  },
  // 根据IP获取当前城市
  getCityByIP(data) {
    return axios.post('/home/getCityByIP', data, {baseURL: axios.defaults.roomFindWeb})
  },
  // 获取城市列表
  cityList() {
    return axios.get('/find/filterCityList',{baseURL: axios.defaults.roomFindWeb}, {timeout: 1000 * 10})
  },
  // 获取房东服务城市列表
  roomCitysByLandlordId(data) {
    return axios.post('/zgg/roomCitysByLandlordId', data, {baseURL: axios.defaults.roomFindWeb})
  },
  // 检查房东店铺是否能用，返回true标识禁用，false才能正常使用
  checkCanUseShop(data) {
    return axios.get("/ali/checkCanUseShop", { baseURL: axios.defaults.roomFindWeb, params: data });
  },
}



// WEBPACK FOOTER //
// ./src/api/roomFindWeb.js